
import Vue from 'vue'
import ErrorAlert from '@/components/alert/ErrorAlert.vue'
import { AuthenticationResponse, loginApi } from '@/api/auth/login'
import store from '@/store'
import { isRequiredGenerator } from '@/utils/rules'
import SwitchLocale from '@/components/SwitchLocale.vue'
import { isString } from 'lodash'
import { handleAxiosException } from '@/api'

export default Vue.extend({
  components: {
    ErrorAlert,
    SwitchLocale,
  },
  data() {
    return {
      form: {
        password: '',
        email: '',
      },
      errorMessage: '',
      authState: store.state,
      loading: false,
    }
  },
  methods: {
    isRequiredGenerator,
    routerRedirect() {
      const searchParams = new URLSearchParams(window.location.search)
      const url = searchParams.get('redirect')
      if (url) {
        this.$router.push(url)
      } else {
        this.$router.push('/')
      }
    },
    loginByCredentials() {
      if ((this.$refs.form as HTMLFormElement).validate()) {
        this.login(() => loginApi.login(this.form.email, this.form.password))
      }
    },
    async login(requestCallback: () => Promise<AuthenticationResponse>) {
      this.errorMessage = ''
      this.loading = true
      try {
        const response = await requestCallback()
        store.setUserInfo(response)
      } catch (error) {
        if (handleAxiosException(error) === 'error.disabled_account') {
          this.$router.push({ name: 'trigger-activation', params: { email: this.form.email } })
        } else {
          this.errorMessage = this.$t(handleAxiosException(error) ?? 'form.error.global_error') as string
        }
        this.form.password = ''
      }
      this.loading = false
      if (this.authState.authenticated) {
        this.routerRedirect()
      }
    },
    showMessageError(message: string) {
      this.errorMessage = message
      this.loading = false
    },
    isTrot(): boolean {
      return !!process.env.VUE_APP_IS_TROT
    },
  },
  async mounted() {
    let token: string
    if (this.$route.query.token) {
      store.logout()
      loginApi.logout()
      if (isString(this.$route.query.token)) {
        token = this.$route.query.token
      } else {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        token = this.$route.query.token[0]!
      }
      this.login(() => loginApi.loginAs(token))
    }
  },
})
